import PropTypes from 'prop-types'
import LinkButton from '../ui/LinkButton'
import './TiendasOficiales.css'

function EmpresasTiendasOficiales({ tienda }) {
  const { esBanner, idUsuario, path, nombreTienda } = tienda
  return (
    <>
      {esBanner === false ? (
        <div className="col cuadro-tienda-oficial">
          <LinkButton
            className="btn link-button-tienda"
            to={{
              pathname: `/Publicaciones/TiendasOficiales/${idUsuario}`,
              state: { path }
            }}
          >
            <img className="logo-tienda-oficial" src={path} alt={nombreTienda} />
          </LinkButton>
        </div>
      ) : null}
    </>
  )
}

EmpresasTiendasOficiales.propTypes = {
  tienda: PropTypes.shape({
    esBanner: PropTypes.bool,
    idUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    path: PropTypes.string,
    nombreTienda: PropTypes.string
  }).isRequired
}

export default EmpresasTiendasOficiales
